module.exports = __webpack_public_path__ + "img/avatar-05-120x120.1a7d9444.png";